var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"messanger",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('img',{ref:"imgMessanger",attrs:{"src":'/img/' + _vm.imgName,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }